import type { ParentComponent, ParentProps } from "solid-js";

const ContentSection: ParentComponent<ParentProps> = (props) => (
  <div class="relative w-full rounded-lg border border-subtle bg-surface-default p-6">{props.children}</div>
);

export default ContentSection;
